import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';
export const ListTags = loadable(() => import('./List'), {
  fallback: <FullPageLoader />,
});
export * from './List';
